import React, { useMemo } from "react";
import { format, parseISO } from "@scrile/tools/dist/lib/TimeHelpers";
import { useTranslation } from "locales";
import { getDateFnsLocale } from "lib/dateLocale";
import "./style.scss";

interface Props {
  date: string;
}

function DateSeparator({ date }: Props) {
  const { t } = useTranslation();

  const label = useMemo(() => {
    const parsed = parseISO(date);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today.getTime() - 86400000);
    const messageDate = new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());

    if (messageDate.getTime() === today.getTime()) {
      return t("Today");
    }
    if (messageDate.getTime() === yesterday.getTime()) {
      return t("Yesterday");
    }
    return format(parsed, "d MMMM yyyy", { locale: getDateFnsLocale() });
  }, [date, t]);

  return (
    <div className="date-separator">
      <span className="date-separator__label">{label}</span>
    </div>
  );
}

export default DateSeparator;
